import React from "react";
import ReactDOM from "react-dom";
import {
  StyledNotification,
  StyledNotificationCircle,
  StyledNotificationOverlay,
} from "./Notification.styled";
import { IconManager } from "../IconManager/IconManager";
import { FontWeightEnum, IconSizeEnum } from "../../../types/AppTypes";
import { ReactComponent as CheckIcon } from "../../../icons/check.svg";
import { ReactComponent as WarningIcon } from "../../../icons/warning.svg";
import { ReactComponent as ErrorIcon } from "../../../icons/close.svg";
import { theme } from "../../../constants/StyledComponents";
import { Button, ButtonSizes } from "../Button/Button";
import { OK_LABEL } from "../../../constants/Dictionary";
import { useNotification } from "../../../hooks/notification.hook";
import { BodyTyp, TitlesTyp } from "../../Typography/Typography";

export enum NotificationTypeEnum {
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
}

export type NotificationProps = {
  title: string;
  subtitle: string;
  type: NotificationTypeEnum;
};

const getNotificationIcon = (type: NotificationTypeEnum): React.ReactNode => {
  switch (type) {
    case NotificationTypeEnum.SUCCESS:
      return <CheckIcon />;
    case NotificationTypeEnum.WARNING:
      return <WarningIcon />;
    case NotificationTypeEnum.ERROR:
      return <ErrorIcon />;
  }
};

export const Notification = ({ title, subtitle, type }: NotificationProps) => {
  const { removeNotification } = useNotification();

  return ReactDOM.createPortal(
    <StyledNotificationOverlay>
      <StyledNotification>
        <StyledNotificationCircle $type={type}>
          <IconManager size={IconSizeEnum.LARGE} color={theme.colors.white}>
            {getNotificationIcon(type)}
          </IconManager>
        </StyledNotificationCircle>
        <TitlesTyp fontWeight={FontWeightEnum.SEMIBOLD} variant={"3"}>
          {title}
        </TitlesTyp>
        <div className="text-container">
          <BodyTyp fontWeight={FontWeightEnum.REGULAR} variant={"1"}>
            {subtitle}
          </BodyTyp>
        </div>
        <Button
          label={OK_LABEL}
          size={ButtonSizes.SMALL}
          onClick={() => removeNotification()}
        />
      </StyledNotification>
    </StyledNotificationOverlay>,
    document.body,
  );
};
